import { render, staticRenderFns } from "./ChosenUniversity.html?vue&type=template&id=3af35fce&scoped=true&"
import script from "./ChosenUniversity.vue?vue&type=script&lang=js&"
export * from "./ChosenUniversity.vue?vue&type=script&lang=js&"
import style0 from "./ChosenUniversity.scss?vue&type=style&index=0&id=3af35fce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af35fce",
  null
  
)

export default component.exports